export default __webpack_public_path__ + "static/media/029-angelfish.fe819627.svg";